'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _types = require('./types');

var _getKey = require('./utils/getKey');

var _getKey2 = _interopRequireDefault(_getKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  positions: {}
};

exports.default = (0, _typeToReducer3.default)((0, _defineProperty3.default)({}, _types.GET_POSITION, function (state, _ref) {
  var level = _ref.level,
      column = _ref.column,
      index = _ref.index,
      position = _ref.position;

  return (0, _extends4.default)({}, state, {
    positions: (0, _extends4.default)({}, state.positions, (0, _defineProperty3.default)({}, (0, _getKey2.default)(level, column, index), position))
  });
}), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobCareerMap/reducer.js
// module id = 1176
// module chunks = 0